"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAbortableInterval = exports.setAbortableTimeout = void 0;
/**
 * setTimeout with AbortSignal support. Aborting will simply clear
 * the timeout silently.
 */
const setAbortableTimeout = (cb, ms, abortSignal) => {
    if (abortSignal.aborted) {
        return;
    }
    const abortListener = () => {
        clearTimeout(timeoutRef);
    };
    abortSignal.addEventListener('abort', abortListener, { once: true });
    const timeoutRef = setTimeout(() => {
        abortSignal.removeEventListener('abort', abortListener);
        cb();
    }, ms);
};
exports.setAbortableTimeout = setAbortableTimeout;
/**
 * setInterval with AbortSignal support. Aborting will simply clear
 * the interval silently.
 */
const setAbortableInterval = (cb, ms, abortSignal) => {
    if (abortSignal.aborted) {
        return;
    }
    const abortListener = () => {
        clearInterval(timeoutRef);
    };
    abortSignal.addEventListener('abort', abortListener, { once: true });
    const timeoutRef = setInterval(() => {
        cb();
    }, ms);
};
exports.setAbortableInterval = setAbortableInterval;
//# sourceMappingURL=abortableTimers.js.map